import { displayName } from 'utils';

export const decorateContact = (contact) => {
  if (contact) {
    return { ...contact, displayName: displayName(contact.firstName, contact.lastName) };
  }
  return undefined;
};
